import React from "react";
import { HelperWidget } from "./helper";

export function Chatbot() {
  return <HelperWidget />;
}
